import React from 'react';
import styled from 'styled-components';

import { colors } from '../../../core/colors';
import Text from '../Text';
import Tooltip from '../Tooltip';

export interface ChipProps {
  size?: 'small' | 'medium';
  color?: string;
  backGroundColor?: string;
  onClick?: () => void;
  label?: string;
  tooltipId?: string;
  children?: React.ReactNode;
}

const ChipContainer = styled.div<ChipProps>`
  display: flex;
  text-align: center;
  justify-content: center;
  align-items: center;
  border-radius: 10px;
  border: ${({ color }) => `1px solid ${color}`};
  background-color: ${({ backGroundColor = colors.primary }) => backGroundColor};
  min-width: 120px;
  max-width: 200px;
  height: 20px;

  p {
    padding: 1px 10px;
  }
`;

const Chip = ({ label, color, tooltipId, children, ...rest }: ChipProps) => {
  return (
    <ChipContainer {...rest}>
      {tooltipId && children ? <Tooltip id={tooltipId}>{children}</Tooltip> : null}
      <Text data-tip="" data-for={tooltipId || ''} size="xsmall" noMargin color={color}>
        {label}
      </Text>
    </ChipContainer>
  );
};

export default Chip;
